// extracted by mini-css-extract-plugin
module.exports = {"upload-box":"_5vTRc","drag-over":"CU+XR","inner":"nyQbE","text":"rJael"};